export default "__VITE_ASSET__CDdUWxYg__"